import { string } from 'yup'

export const tel = () => string().matches(/^\+?(-(?!-)|\d)+\d$/, { excludeEmptyString: true })
